import React, { CSSProperties } from 'react'
import styled from 'styled-components'
import { CardView } from 'src/Component/Card'
import { ReactComponent as ChevronIcon } from 'images/chevron.svg'
import { Title1, Body } from 'src/Styles/text-styles'

const Title = styled(Title1)`
  font-weight: 500;
  @media (min-width: 480px) {
    margin-right: 4px;
    margin-left: 4px;
    margin-bottom: 4px;
    line-height: 24px;
  }
  @media (max-width: 480px) {
    margin-right: 4px;
    margin-left: 4px;
    margin-bottom: 4px;
    line-height: 24px;
  }
  @media (min-width: 768px) {
    margin-right: 8px;
    margin-left: 8px;
    margin-bottom: 8px;
    line-height: 32px;
  }
`
const CardDescription = styled(Body)`
  font-weight: 400;
  line-height: 20px;
  @media (min-width: 480px) {
    margin: 4px;
  }
  @media (max-width: 480px) {
    margin: 4px;
  }
  @media (min-width: 768px) {
    margin: 8px;
  }
`

const Row = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const Col = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`
interface Props {
  title: string
  description: string
  style?: CSSProperties
  InfoIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  showChevronIcon?: boolean
  onPress?(): void
}
const CardInfo = ({
  title,
  description,
  style,
  InfoIcon,
  showChevronIcon = true,
  onPress,
}: Props) => {
  const infoStyle = { marginRight: '8px' }

  const onCardPress = () => {
    if (onPress) {
      onPress()
    }
  }

  return (
    <CardView style={style} onPress={onCardPress}>
      <Row>
        <Col>
          <Row>
            <InfoIcon width={28} height={28} style={infoStyle} />
            <Col>
              <Title>{title}</Title>
              <CardDescription>{description}</CardDescription>
            </Col>
          </Row>
        </Col>
        {showChevronIcon && <ChevronIcon width={16} height={16} />}
      </Row>
    </CardView>
  )
}

export default CardInfo
